import React, { Component } from "react";
import { scoreCardGameURL } from "../../../utils/common.utils";
//images
import ppd from "../../../images/score/ppd.png";
import orgIc from "../../../images/icon/org-ic.png";
import star1 from "../../../images/score/star1.png";
import { getLeaderBoardDetails } from "../../../utils/Tournament.utils";
import Image from "../../common/Image";
import SponsorCards from "./Scorecards/SponsorCards";

export default class PrizePoolDistribution extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tournamentDetails: props.tournamentDetails,
      leaderBoardDetails: null,
    };
    this.gameUrl = scoreCardGameURL(props.tournamentDetails?.gameDetails?.name);
  }

  componentDidMount() {
    getLeaderBoardDetails(this.props.tournamentDetails._id, this.setLeaderBoardDetails);
  }

  setLeaderBoardDetails = data => {
    this.setState({
      leaderBoardDetails: data,
    });
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      tournamentDetails: nextProps.tournamentDetails,
    });
  }

  renderPrizeCard = (rank, prizeDistribution, leaderBoard, isTeamGame) => {
    const participant = isTeamGame ? leaderBoard?.teamDetails : leaderBoard?.participantDetails;
    const participantName = isTeamGame ? participant?.name : participant?.inGameName;
    const participantImage = isTeamGame ? participant?.logo?.url : participant?.profilePicture?.url;
    const hasWinner = participant && participantName;

    return (
      <div
        className="col-lg-8 col-md-10 col-12 prize-card mb-4 p-4 rounded-lg"
        style={{ backgroundColor: "rgba(255, 255, 255, 0.05)" }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div
              className="rank-badge me-3 position-relative"
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                background:
                  rank === 1
                    ? "linear-gradient(135deg, #FFD700, #FFA500)"
                    : rank === 2
                      ? "linear-gradient(135deg, #C0C0C0, #A9A9A9)"
                      : "linear-gradient(135deg, #CD7F32, #8B4513)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 0 20px rgba(255, 255, 255, 0.1)",
              }}
            >
              <span className="fw-bold text-white fs-18">#{rank}</span>
            </div>
            <div className="d-flex align-items-center">
              {hasWinner ? (
                <>
                  <Image
                    src={participantImage}
                    param={participantName}
                    className="rounded-circle me-2"
                    style={{ width: "40px", height: "40px", objectFit: "cover" }}
                  />
                  <h5 className="text-white mb-0 mt-1">{participantName}</h5>
                </>
              ) : (
                <div className="tbd-container">
                  <div
                    className="tbd-badge px-3 py-1 rounded-pill"
                    style={{
                      background:
                        "linear-gradient(90deg, rgba(255,255,255,0.1), rgba(255,255,255,0.2))",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    <span className="text-white fw-bold">TBD</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="prize-amount d-flex align-items-center">
            <img
              src={star1}
              alt="star"
              style={{ width: "24px", height: "24px" }}
              className="me-2"
            />
            <span className="fs-18 fw-bold text-white">EC {prizeDistribution?.prizeAmount}</span>
            {prizeDistribution.merchandise && (
              <>
                <span className="mx-2 text-white">×</span>
                <div className="d-flex align-items-center">
                  <img
                    src={prizeDistribution.merchandiseImage.url}
                    alt={prizeDistribution.merchandiseHeading}
                    style={{ width: "32px", height: "32px" }}
                    className="me-2"
                  />
                  <span className="text-white fw-400">{prizeDistribution.merchandiseHeading}</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { tournamentDetails, leaderBoardDetails } = this.state;
    const organizationDetails = this.state.tournamentDetails?.organizationDetails;
    const isTeamGame = tournamentDetails?.participantType === "TEAM";
    const prizeDetails = tournamentDetails?.entryFeeAndPrizeDetails;
    const leaderBoardsArr = [];

    if (!prizeDetails?.prizeDistribution?.length) {
      return (
        <div className="text-center p-4">
          <p className="text-white fw-500">No prize pool for this tournament</p>
        </div>
      );
    }

    const leaderBoard =
      leaderBoardDetails?.leaderBoard[leaderBoardDetails.leaderBoard.length - 1] || [];
    const prizeDistribution = prizeDetails.prizeDistribution;
    Object.keys(leaderBoard).forEach(function (key) {
      leaderBoardsArr.push(leaderBoard[key]);
    });

    return (
      <div className="prize-pool-container p-4">
        <div className="d-flex align-items-center mb-4">
          <img src={ppd} alt="" className="me-2" />
          <h3 className="text-white mb-0">Prize Pool Distribution</h3>
        </div>

        <div className="prize-list">
          <div className="d-flex align-items-center justify-content-center mb-4">
            {organizationDetails?.logo?.url && (
              <img
                src={organizationDetails ? organizationDetails?.logo?.url : orgIc}
                className="mt-2 me-2"
                alt=""
                style={{ zIndex: "1", height: "40px" }}
              />
            )}
            <h5 className="text-white fw-bold fs-20 mt-2 mb-0">{organizationDetails?.name}</h5>
          </div>
          <div className="row justify-content-center">
            {prizeDistribution.map((prize, index) => (
              <React.Fragment key={index}>
                {this.renderPrizeCard(index + 1, prize, leaderBoardsArr[index], isTeamGame)}
              </React.Fragment>
            ))}
          </div>
        </div>

        <SponsorCards tournamentDetails={tournamentDetails} />
      </div>
    );
  }
}
